import { getCookie } from 'cookies-next'

import { SELECTED_PROJECT_COOKIE_KEY } from '@/components/entities/common/model/selected-project.store'

import { ProjectResponse } from './auth.types'

export const isSelectedProjectAvailable = (
  projectList: ProjectResponse[]
): boolean => {
  const selectedProjectId = getCookie(SELECTED_PROJECT_COOKIE_KEY)

  return (
    !selectedProjectId || projectList.some(({ id }) => id === selectedProjectId)
  )
}
